"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NavigationHistoryService = /** @class */ (function () {
    function NavigationHistoryService($rootScope) {
        this.$rootScope = $rootScope;
        this.historyStates = [];
        this.isGoingBack = false;
        this.getHistory = this.getHistory.bind(this);
        this.trackHistory = this.trackHistory.bind(this);
        this.closeSidebar = this.closeSidebar.bind(this);
        this.slideSidebar = this.slideSidebar.bind(this);
        this.trackHistoryForBackButtonDirective =
            this.trackHistoryForBackButtonDirective.bind(this);
        // close sidebar menu on successful state change
    }
    NavigationHistoryService.prototype.init = function () {
        this.$rootScope.$on("$stateChangeStart", this.trackHistory);
        this.$rootScope.$on("$stateChangeSuccess", this.closeSidebar);
        this.$rootScope.$on("$stateChangeSuccess", this.trackHistoryForBackButtonDirective);
    };
    NavigationHistoryService.prototype.trackHistory = function (event, next) {
        this.historyStates.push(next.name);
        if (this.historyStates.length > 2 &&
            this.historyStates[this.historyStates.length - 1] ===
                this.historyStates[this.historyStates.length - 3]) {
            this.isGoingBack = true;
            this.historyStates.pop();
            this.historyStates.pop();
        }
        else if (this.historyStates.length > 0 &&
            next.name === "drivecoach.admin.dashboard") {
            this.isGoingBack = true;
            this.historyStates = ["drivecoach.admin.dashboard"];
        }
        else {
            this.isGoingBack = false;
        }
        try {
            var slidey = document.querySelector(".slidey");
            if (this.isGoingBack) {
                slidey.classList.add("slide-exit-bottom");
            }
            else {
                slidey.classList.add("slide-exit-left");
            }
        }
        catch (e) { }
    };
    NavigationHistoryService.prototype.closeSidebar = function (event, to, toParams, from, fromParams) {
        var menuContainer = document.getElementById("st-container");
        if (menuContainer) {
            menuContainer.classList.remove("st-menu-open");
        }
    };
    NavigationHistoryService.prototype.slideSidebar = function () {
        // slidey
        var slidey = document.querySelector(".slidey");
        if (slidey) {
            if (this.isGoingBack) {
                setTimeout(function () {
                    slidey.classList.add("slide-enter-left");
                    slidey.classList.remove("slide-exit-bottom");
                }, 400);
                setTimeout(function () {
                    slidey.classList.remove("slide-enter-left");
                    slidey.classList.add("slide-enter-active");
                }, 800);
            }
            else {
                setTimeout(function () {
                    slidey.classList.add("slide-enter-bottom");
                    slidey.classList.remove("slide-exit-left");
                }, 400);
                setTimeout(function () {
                    slidey.classList.remove("slide-enter-bottom");
                    slidey.classList.add("slide-enter-active");
                }, 800);
            }
        }
    };
    NavigationHistoryService.prototype.trackHistoryForBackButtonDirective = function (event, to, toParams, from, fromParams) {
        this.previousState = {
            name: from.name,
            params: fromParams,
        };
        this.currentState = {
            name: to.name,
            params: toParams,
        };
    };
    NavigationHistoryService.prototype.getHistory = function () {
        return {
            length: this.historyStates.length,
            currentState: this.historyStates[this.historyStates.length - 1],
        };
    };
    return NavigationHistoryService;
}());
NavigationHistoryService.$inject = ["$rootScope"];
exports.default = NavigationHistoryService;
